import { Trans } from "@lingui/react/macro";
import { SectionContainer } from "@silversea-ssc/ui-components-react";
import { BlockContent } from "components/BlockContent";
import ShipDeckPlanSection from "components/ShipDeckPlanSection/ShipDeckPlanSection";
import React from "react";
import { isPresent } from "src/utils/checks";
import { ShipPageVersionFragment } from "types/graphql-types";
import ShipCardsSection from "./ShipCardsSection";
import { ShipPageModalContents } from "./types";

type ShipVersionContentProps = {
  shipName: string;
  version: ShipPageVersionFragment;
  openModal: (item: ShipPageModalContents) => void;
  spacingTop: undefined | "compact";
};

const ShipVersionContent: React.FC<ShipVersionContentProps> = ({
  shipName,
  version,
  openModal,
  spacingTop
}) => {
  const suites = version.suites?.filter(isPresent)?.filter((s) => s.card);
  const diningAreas = version.diningAreas?.filter(isPresent);
  const facilities = version.facilities?.filter(isPresent);

  return (
    <React.Fragment>
      {isPresent(version.deckPlanPdf?.asset?.url) && (
        <SectionContainer
          backgroundColor="neutral05"
          spacingTop={spacingTop}
          spacingBottom={undefined}
        >
          <ShipDeckPlanSection
            shipName={shipName}
            // eslint-disable-next-line @typescript-eslint/no-non-null-asserted-optional-chain, @typescript-eslint/no-non-null-assertion
            deckPlanUrl={version.deckPlanPdf?.asset?.url!}
            lateralViewImage={version.lateralViewImage}
            crewCount={version.crewCount}
            passengerCount={version.passengerCount}
            buildYear={version.buildYear}
            lastRefurbishmentYear={version.lastRefurbishmentYear}
            tonnage={version.tonnage}
          >
            <BlockContent value={version.deckPlanDescription?.localized} />
          </ShipDeckPlanSection>
        </SectionContainer>
      )}

      {suites && suites.length > 0 && (
        <ShipCardsSection
          backgroundColor="neutral05"
          dataContentName="suites"
          title={<Trans>Suites</Trans>}
          icon="suites"
          items={suites}
          openModal={(item) =>
            openModal({
              type: "suite",
              suiteCode: item.codes ? item.codes[0] : undefined,
              versionKey: version._key!
            })
          }
        />
      )}

      {diningAreas && diningAreas.length > 0 && (
        <ShipCardsSection
          backgroundColor="white"
          dataContentName="dining"
          title={<Trans>Dining</Trans>}
          icon="dining"
          items={diningAreas}
          openModal={(item) =>
            openModal({
              type: "diningArea",
              content: item,
              versionKey: version._key!
            })
          }
        />
      )}

      {facilities && facilities.length > 0 && (
        <ShipCardsSection
          shipNotReadyDisclaimer={version?.shipNotReadyDisclaimer?.localized}
          backgroundColor="neutral05"
          dataContentName="public_areas"
          title={<Trans>Public Areas</Trans>}
          icon="public-area"
          items={facilities}
          openModal={(item) =>
            openModal({
              type: "facility",
              content: item,
              versionKey: version._key!
            })
          }
        />
      )}
    </React.Fragment>
  );
};

export default ShipVersionContent;
